import MenuIcon from '@mui/icons-material/Menu';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { Box, Divider, Drawer, Hidden, IconButton, List, ListItem, Tooltip } from '@mui/material';
import Cookies from "js-cookie";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Outlet, useLocation } from 'react-router-dom';
import IconNewActivity from '../../../assets/icons/AdminDashboard/AddIcon.svg';
import IconNewActivityOn from '../../../assets/icons/AdminDashboard/AddIconOn.svg';
import IconGamizignWorld from '../../../assets/icons/AdminDashboard/DashboardIconOff.svg';
import IconGamizignWorldOn from '../../../assets/icons/AdminDashboard/DashboardIconOn.svg';
import IconGamizign from '../../../assets/icons/AdminDashboard/GamizignIconOff.svg';
import IconGamizignOn from '../../../assets/icons/AdminDashboard/GamizignIconOn.svg';
import LogoPic1Dark from '../../../assets/icons/AdminDashboard/Gmz_logo_dark.svg';
import LogoPic1 from '../../../assets/icons/AdminDashboard/Gmz_logo_light.svg';
import IconInsights from '../../../assets/icons/AdminDashboard/InsightsIconOff.svg';
import IconInsightsOn from '../../../assets/icons/AdminDashboard/InsightsIconOn.svg';
import IconLearnerList from '../../../assets/icons/AdminDashboard/LearnerListsIconOff.svg';
import IconLearnerListOn from '../../../assets/icons/AdminDashboard/LearnerListsIconOn.svg';
import IconQuestionList from '../../../assets/icons/AdminDashboard/QuestionListIconOff.svg';
import IconQuestionListOn from '../../../assets/icons/AdminDashboard/QuestionListIconOn.svg';
import IconSettings from '../../../assets/icons/AdminDashboard/SettingsIconOff.svg';
import IconSettingsOn from '../../../assets/icons/AdminDashboard/SettingsIconOn.svg';
import UpgradeIcon from "../../../assets/icons/UpgradeIcon.svg";
import AppleStore from '../../../assets/images/Apple-store.png';
import LogoPic from '../../../assets/images/Gamizign-logo.png';
import Googlelay from '../../../assets/images/Google-Play.png';
import "../../../i18n";
import UpgradingDialog from '../../GlobalComponents/UpgradingDialog';
import CheckList, { toDoList } from "../../LoginHeading/CheckList";
import './style.css';
import HeadingOfLicne from '../../GlobalComponents/headingOfLicen';

const Dashboard = ({ mode, drawerWidth, setDrawerWidth }) => {
  const { t, i18n } = useTranslation();
  const Tab = parseInt(sessionStorage.getItem("tab"));
  const [selectedTab, setSelectedTab] = useState(null);
  const LearnersList = localStorage.getItem("LearnersList");
  const LicenceType = parseInt(Cookies.get("plan"));
  const CoursesLength = parseInt(localStorage.getItem("accountActive"));
  const defaultUrl = useLocation().pathname;

  useEffect(() => {
    if (defaultUrl === '/Dashboard/Chat'||defaultUrl === '/Dashboard/play') {
      setDrawerWidth(60);
    }
    const currentPage = menuItems.find((tab) => tab.link === window.location.pathname)?.id ?? ((LicenceType === 3 || LicenceType === 5) ? 11 : 4);
    if (Tab) {
      setSelectedTab(Tab);
    } else {
      setSelectedTab(currentPage);
      sessionStorage.setItem("tab", currentPage);
    }
  }, [Tab, defaultUrl]);

  const menuItems = [
    { tooltip: (LicenceType === 3 || LicenceType === 5) ? '' : 'Upgrade to enable', id: 11, icon: IconGamizignWorld, iconOn: IconGamizignWorldOn, label: t('SideBar.TheGamizignWorld'), link: (LicenceType === 3 || LicenceType === 5) ? '/Dashboard' : defaultUrl },
    { id: 1, icon: IconNewActivity, iconOn: IconNewActivityOn, label: t('SideBar.NewActivity'), link: '/Dashboard/CreateCourse' },
    { id: 2, icon: IconQuestionList, iconOn: IconQuestionListOn, label: t('SideBar.QuestionLists'), link: '/Dashboard/questionList' },
    { id: 3, icon: IconGamizign, iconOn: IconGamizignOn, label: t('SideBar.Gamizign'), link: '/Dashboard/Courses' },
    { id: 4, icon: IconInsights, iconOn: IconInsightsOn, label: t('SideBar.Insights'), link: '/Dashboard/insights' },
    { id: 6, icon: IconLearnerList, iconOn: IconLearnerListOn, label: t('SideBar.LearnerList'), link: '/Dashboard/learnerList' },
    { id: 9, icon: IconSettings, iconOn: IconSettingsOn, label: t('SideBar.Settings'), link: '/Dashboard/settings' },
  ];

  const [mobileOpen, setMobileOpen] = useState(false);
  const [showCheckList, setShowCheckList] = useState(false);

  const handleTabClick = (event, tabId) => {
    if (LicenceType !== 3 && LicenceType !== 5 && tabId === 11) {
      setErrorMessage(t("SideBar.NoAbilityDashboard"));
    }
    if (!mobileOpen && window.innerWidth < 1024) {
      setDrawerWidth(60);
    }
    if (event.ctrlKey) {
      return;
    }
    if (LicenceType === 3 || LicenceType === 5) {
      setSelectedTab(tabId);
      sessionStorage.setItem("tab", tabId);
    } else if (tabId !== 11) {
      setSelectedTab(tabId);
      sessionStorage.setItem("tab", tabId);
    }
    if (LicenceType === 3 || LicenceType === 5) {
      setSelectedTab(tabId);
      sessionStorage.setItem("tab", tabId);
    } else if (tabId !== 11) {
      setSelectedTab(tabId);
      sessionStorage.setItem("tab", tabId);
    }
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const doneCount = toDoList.filter(item => item.status).length;
  const [errorMessage, setErrorMessage] = useState(false);

  const closeDialog = () => {
    setErrorMessage(false);
  };

  const drawer = (
    <div className={`flex flex-col h-full justify-between transition-colors duration-300 ${mode === 'light' ? 'bg-slate-50 text-slate-800' : 'bg-slate-900 text-slate-100'}`}>
      <div>
        {/* Header GMZ Logo */}
        <Box
          component="div"
          className={`flex justify-center items-center h-16 border-b transition-colors duration-300 ${mode === 'light'
            ? 'bg-slate-100/50 border-slate-200/60'
            : 'bg-slate-950/40 border-slate-800/50'
            }`}
        >
          <img src={mode === 'light' ? LogoPic1Dark : LogoPic1} alt="Logo" className="hover:scale-105 transition-transform" />
          {drawerWidth === 240 && (
            <span className="font-black text-sm tracking-widest ml-2 uppercase bg-gradient-to-r from-cyan-500 to-blue-500 bg-clip-text text-transparent">
              GAMIZIGN
            </span>
          )}
        </Box>

        {/* Onboarding mission tracker quick launch widget */}
        {LearnersList === 'show' && (
          <div className="p-3">
            <div
              onClick={() => setShowCheckList(!showCheckList)}
              className={`group flex flex-col gap-2 p-3 rounded-2xl border transition-all duration-300 cursor-pointer ${mode === 'light'
                ? 'bg-white border-slate-200/80 hover:border-blue-400 hover:shadow-md'
                : 'bg-slate-950/40 border-slate-800/80 hover:border-cyan-500/50 hover:shadow-[0_0_12px_rgba(6,182,212,0.15)]'
                } ${drawerWidth === 60 ? 'items-center justify-center' : ''}`}
            >
              <div className="flex items-center gap-2.5">
                <div className="w-8 h-8 rounded-lg bg-cyan-500/10 text-cyan-500 flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform animate-pulse">
                  <RocketLaunchIcon fontSize="small" className={i18n.language === 'ar' ? 'scale-x-[-1]' : ''} />
                </div>
                {drawerWidth === 240 && (
                  <div className="flex-1 min-w-0">
                    <div className="flex justify-between items-center">
                      <span className={`text-xs font-black uppercase tracking-wider ${mode === 'light' ? 'text-slate-800' : 'text-slate-200'}`}>
                        {t('GetStarted.GetStarted')}
                      </span>
                      <span className="text-[10px] font-extrabold text-cyan-500 bg-cyan-500/10 px-2 py-0.5 rounded-full">
                        {((doneCount / toDoList.length) * 100).toFixed(0)}%
                      </span>
                    </div>
                    {/* Glowing progress slider track */}
                    <div className="w-full h-1.5 bg-slate-800/20 dark:bg-slate-800 rounded-full overflow-hidden mt-1.5 relative">
                      <div
                        className="h-full bg-gradient-to-r from-cyan-500 to-blue-500 rounded-full transition-all duration-500"
                        style={{ width: `${((doneCount / toDoList.length) * 100).toFixed(0)}%` }}
                      ></div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        <Divider className={mode === 'light' ? 'border-slate-200/60' : 'border-slate-800/50'} />

        {/* Menu Items */}
        <List className="flex flex-col gap-1 p-2">
          {menuItems.map((item, index) => {
            const isSelected = selectedTab === item.id;
            const isLapsedDashboard = LicenceType !== 3 && LicenceType !== 5 && item.id === 11;

            return (
              <Tooltip key={item.id} arrow title={item.tooltip} placement={i18n.language === 'ar' ? 'left' : 'right'}>
                <Link
                  className={`${item.id === 6 && LearnersList === 'hide' ? 'hidden' : ''}`}
                  id={`step-${index + 1}`}
                  to={item.link}
                  style={{ textDecoration: 'none' }}
                >
                  <ListItem
                    onClick={(event) => { handleTabClick(event, item.id); setMobileOpen(false); }}
                    className={`relative group flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all duration-300 ${isSelected
                      ? (mode === 'light' ? 'bg-blue-500/10 text-blue-600 font-bold' : 'bg-cyan-500/10 text-cyan-400 font-bold')
                      : (mode === 'light' ? 'text-slate-600 hover:bg-slate-100 hover:text-slate-900' : 'text-slate-400 hover:bg-slate-800/40 hover:text-slate-200')
                      } ${drawerWidth === 60 ? 'justify-center' : ''}`}
                  >
                    {/* Selected Left/Right pill marker */}
                    {isSelected && (
                      <span className={`absolute top-2 bottom-2 w-1 rounded-full ${mode === 'light' ? 'bg-blue-600' : 'bg-cyan-400'
                        } ${i18n.language === 'ar' ? 'right-0' : 'left-0'}`}></span>
                    )}

                    {/* Menu Item Icon Wrapper */}
                    <div className={`flex items-center justify-center transition-transform duration-300 group-hover:scale-105 ${drawerWidth === 60 ? 'mx-auto' : ''
                      }`}>
                      <img
                        src={isSelected ? item.iconOn : item.icon}
                        // src={isSelected ? (mode === 'light') ?  item.icon : item.iconOn : (mode === 'light') ? item.iconOn : item.icon}
                        alt=""
                        className="w-5 h-5 object-contain"
                      />
                    </div>

                    {/* Menu Item Text Label */}
                    {drawerWidth === 240 && (
                      <span className={`text-xs font-semibold flex-1 ${i18n.language === 'ar' ? 'text-right' : 'text-left'}`}>
                        {item.label}
                      </span>
                    )}

                    {/* Premium Upgrade Badge for lapsed features */}
                    {isLapsedDashboard && drawerWidth === 240 && (
                      <img src={UpgradeIcon} alt="UpgradeIcon" className="w-4 h-4 ml-auto" />
                    )}
                  </ListItem>
                </Link>
              </Tooltip>
            );
          })}
        </List>
      </div>

      {/* Drawer Bottom Actions Area */}
      <div>
        <Divider className={mode === 'light' ? 'border-slate-200/60' : 'border-slate-800/50'} />

        {/* Toggle Collapse/Expand Button */}
        <div className="flex justify-center py-3">
          <button
            type="button"
            onClick={() => { setDrawerWidth(drawerWidth === 60 ? 240 : 60); }}
            className={`p-2 rounded-xl transition-all border flex items-center justify-center ${mode === 'light'
              ? 'bg-slate-100 border-slate-200 text-slate-500 hover:bg-slate-200 hover:text-slate-800'
              : 'bg-slate-800/50 border-slate-700/60 text-slate-400 hover:bg-slate-800 hover:text-slate-200'
              }`}
          >
            <svg
              className={`w-4 h-4 transition-transform duration-300 ${drawerWidth === 60 ? (i18n.language === 'ar' ? '' : 'rotate-180') : (i18n.language === 'ar' ? 'rotate-180' : '')
                }`}
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
            </svg>
          </button>
        </div>

        {/* Dynamic Mobile Store Badges Section */}
        {drawerWidth === 240 && (
          <div className={`p-4 mt-auto rounded-t-3xl transition-colors duration-300 ${mode === 'light' ? 'bg-slate-100/50' : 'bg-slate-950/20'
            }`}>
            <div className="flex justify-between items-center gap-2 mb-3">
              <img src={LogoPic} alt="Logo" className="w-10 h-10 object-contain hover:scale-105 transition-transform" />
              <div className="flex flex-col gap-1.5 flex-1 max-w-[120px]">
                <a target="_blank" rel="noopener noreferrer" href="http://bit.ly/3Tw8PDV" className="hover:opacity-90 transition-opacity">
                  <img src={Googlelay} alt="Google Play Store Badge" className="h-6 w-auto object-contain" />
                </a>
                <a target="_blank" rel="noopener noreferrer" href="https://apple.co/49Pc7I6" className="hover:opacity-90 transition-opacity">
                  <img src={AppleStore} alt="Apple App Store Badge" className="h-6 w-auto object-contain" />
                </a>
              </div>
            </div>

            {/* Legal Links footer */}
            <div className="flex flex-col gap-1 text-[10px] text-slate-500 font-bold border-t border-slate-200/40 dark:border-slate-800/40 pt-2">
              <a href="https://gamizign.com/privacy-policy/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-500 transition-colors">
                {t('SideBar.PrivacyPolicyTerms')}
              </a>
              <span>{t('SideBar.SubscriptionAgreement')}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <div>
      <div className="flex relative">
        <UpgradingDialog open={errorMessage} onClose={closeDialog} message={errorMessage} />

        {/* Sidebar Tabs */}
        <Box
          component="nav"
          sx={{ width: { sm: drawerWidth }, flexShrink: { xs: 0 } }}
        >
          <Hidden smUp implementation="css">
            <Drawer
              labelStyle={{ fontFamily: 'Cairo_Regular' }}
              variant="temporary"
              anchor={i18n.language === 'ar' ? 'right' : 'left'}
              open={mobileOpen}
              onClose={handleDrawerToggle}
              ModalProps={{
                keepMounted: true,
              }}
              sx={{
                display: { xs: 'block', sm: 'none' },
                transition: 'width 0.3s ease-in-out',
                '& .MuiDrawer-paper': {
                  boxSizing: 'border-box',
                  width: drawerWidth,
                  backgroundColor: mode === 'light' ? '#F8FAFC' : '#0F172A',
                  overflowX: 'hidden',
                  transition: 'width 0.3s ease-in-out, transform 0.3s ease-in-out',
                },
              }}
            >
              {drawer}
            </Drawer>
          </Hidden>

          <Hidden xsDown implementation="css">
            <Drawer
              variant="permanent"
              sx={{
                display: { xs: "none", sm: "block" },
                transition: "width 0.25s ease-in-out",
                "& .MuiDrawer-paper": {
                  boxSizing: "border-box",
                  width: drawerWidth,
                  backgroundColor: mode === 'light' ? '#F8FAFC' : '#0F172A',
                  overflowX: "hidden",
                  transition: "width 0.25s ease-in-out",
                  right: i18n.language === "ar" ? 0 : "auto",
                  borderRight: i18n.language === "ar" ? 'none' : (mode === 'light' ? '1px solid #E2E8F0' : '1px solid #1E293B'),
                  borderLeft: i18n.language === "ar" ? (mode === 'light' ? '1px solid #E2E8F0' : '1px solid #1E293B') : 'none',
                },
              }}
              open={!mobileOpen}
            >
              {drawer}
            </Drawer>
          </Hidden>
        </Box>
        <div className={`sm:hidden z-50 fixed top-0 ${i18n.language === 'en' ? 'left-0' : 'right-0'} px-3 h-16 flex items-center`} onClick={handleDrawerToggle}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
          >
            <MenuIcon className={mode === 'light' ? 'text-slate-800' : 'text-white'} />
          </IconButton>
        </div>

        <div className="MAINMENU flex-1">
          <HeadingOfLicne />
          <Outlet />
        </div>

        <CheckList showCheckList={showCheckList} setShowCheckList={setShowCheckList} />
      </div>
    </div>
  );
};
export default Dashboard;